import { defaultEngine, Rule } from 'js-rules-engine';
import { setUpOperators } from './set-up-operators';
setUpOperators(defaultEngine);
export function evaluateOverrideCondition(override, submission = {}) {
    if (override.condition) {
        try {
            const rule = getRule(override.condition);
            return rule.evaluate(submission);
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    return true;
}
function getRule(condition) {
    return new Rule(condition);
}
//# sourceMappingURL=evaluate-override-codition.js.map